/**
 * Provider sunset dates — frontend mirror of supabase/functions/integrations-smoke-cron/sunset-dates.ts.
 *
 * Two copies exist because Deno edge fn cannot import from Vite `@/` alias.
 * Keep in sync manually; both reviewed quarterly.
 * Last reviewed: 2026-04-22.
 *
 * These dates are not returned by provider APIs — they are published in
 * blog posts and changelogs. `integrations-smoke-cron` writes the lookup
 * result into `integrations.metadata.sunset_date`.
 */

export type SunsetProvider = 'meta' | 'google_ads' | 'ghl';
type SunsetTable = Record<SunsetProvider, Record<string, string | null>>;

export const SUNSET_DATES: SunsetTable = {
  meta: {
    'v25.0': '2027-02-18',  // Assumed: 2-year cadence from Feb 18, 2026 release (RESEARCH §A1)
    'v24.0': '2026-08-18',
  },
  google_ads: {
    'v23': null,   // no announced sunset yet
    'v22': null,
    'v19': '2026-02-11',  // past EOL
  },
  ghl: {
    '2021-07-28': null,  // current v2, no announced sunset
  },
};

export function lookupSunset(provider: SunsetProvider, version: string | null): string | null {
  if (!version) return null;
  return SUNSET_DATES[provider]?.[version] ?? null;
}

/** Returns number of days (integer, floor) from `now` to sunset, or null if no sunset date. */
export function daysUntilSunset(sunsetDate: string | null, now: Date = new Date()): number | null {
  if (!sunsetDate) return null;
  const ts = new Date(sunsetDate + 'T00:00:00Z').getTime();
  const nowMs = now.getTime();
  return Math.floor((ts - nowMs) / (24 * 60 * 60 * 1000));
}
